import type { MultiSelectChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import { useEffect, useState } from "react";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { GlobalCarrier } from "~/shared/schemas/auto-dispatch-schema.ts";

import { DaysInAdvanceFilterCell } from "../../components/grid/columns/days-in-advance-filter-cell/index.tsx";
import { HeaderCell } from "../../components/grid/columns/header-cell/index.tsx";
import { daysConstant } from "../../utils/constants.ts";
import type { column } from "./types.ts";
import type { CellWrapper } from "./with-loader.tsx";

const handleClick = (e: React.MouseEvent) => {
	e.stopPropagation();
};

export const dispatchDaysColumn = (
	cellWrapper: CellWrapper,
	updateCarrier: ((carrier: GlobalCarrier) => void) | undefined,
): column => ({
	field: "dispatchDaysInAdvance",
	title: "Days In Advance",
	group: ["global"],
	filter: "numeric",
	filterable: true,
	filterCell: DaysInAdvanceFilterCell,
	sortable: true,
	headerCell: (props) => (
		<HeaderCell
			title={props.title ?? ""}
			tooltipText={
				"Shipments tendered prior to the day of pick up should be auto dispatched at 9PM the night before pick up. If the shipment is tendered day of pick up or post 9PM the day prior to pick up, it can be automatically dispatched at the time of tender to TQL."
			}
		/>
	),
	cells: {
		data: cellWrapper((props) => {
			const carrier = props.dataItem as GlobalCarrier;
			const [localDay, setLocalDay] = useState<number | undefined>(
				carrier?.dispatchDaysInAdvance ?? undefined,
			);

			useEffect(() => {
				setLocalDay(carrier?.dispatchDaysInAdvance ?? undefined);
			}, [carrier?.dispatchDaysInAdvance]);

			const commitDay = () => {
				if (localDay === undefined) return;
				updateCarrier?.({
					...carrier,
					dispatchDaysInAdvance: localDay,
				});
			};

			return (
				<GridTd onClick={handleClick} tdProps={props.tdProps}>
					<DropDownList
						data={daysConstant}
						dataItemKey={"value"}
						defaultItem={{ text: "How many days in advance?", value: 0 }}
						onBlur={commitDay}
						onChange={(e: MultiSelectChangeEvent) => {
							const item = e.value as { value: number } | string;
							if (typeof item !== "string" && item.value !== 0) {
								setLocalDay(item.value);
							}
						}}
						onClose={commitDay}
						textField={"text"}
						value={daysConstant.find((d) => d.value === localDay)}
					/>
				</GridTd>
			);
		}),
	},
});
